export default __webpack_public_path__ + "static/media/facebookprimera.39aab795.svg";